import {
  freeTrialEndModalActions,
  FreeTrialEndModalReasonKeys,
} from '@contentlab/stores/freeTrialEndModalStore';

type OpenTrialUpgradeModalProps = {
  source: string;
  reason: FreeTrialEndModalReasonKeys;
  onSuccess?: () => void;
};

function useTrialUpgradeModal() {
  return (props: OpenTrialUpgradeModalProps) => {
    const {source, reason, onSuccess} = props;
    freeTrialEndModalActions.setFreeTrialEndModalReason(reason);
    freeTrialEndModalActions.setFreeTrialEndModalSource(source);
    if (onSuccess) {
      freeTrialEndModalActions.setOnTrialUpgradeSuccess(onSuccess);
    }
    freeTrialEndModalActions.openFreeTrialEndModal();
  };
}

export default useTrialUpgradeModal;
